import React, { memo, useEffect, useRef, useState } from "react";
import FirstFold from "./FirstFold";
import SecondFold from "./SecondFold";
import ResourceFold from "./ResourceFold";
import MldReturns from "./MldReturns";
import AboutIcm from "./AboutIcm";
import WhyIcm from "./WhyIcm";
import { mldInvest } from "../assets/constants/mld-invest";
import moment from "moment";
import WLTransactionHistory from "./WLTransactionHistory";
import VideoModal from "./VideoModal";
import EstimateModal from "./EstimateModal";
import { OroLoader } from "../../core";
import ConsultBanner from "./ConsultBanner";
import MldMarketingFaq from "./MldMarketingFaq";
import MldRisk from "../assets/constants/MldRisk";
import ReactGA from "react-ga4";
import { setAnalyticsEvent } from "../../core/helpers/analytics";
import { getFaq } from "../services/waitlist-service";
import { toast } from "react-toastify";

const MldAssets = memo(function MldAssets(props) {
  // console.log("MldAssets");
  const [issueList, setIssueList] = useState({});
  const refToLearn = useRef(null);
  const [showVideo, setShowVideo] = useState(false);
  const [showEstimatePopup, setShowEstimatePopup] = useState(false);
  const [firstLevel, setFirstLevel] = useState(24900);
  const [niftyReturns, setNiftyReturns] = useState(20);
  const [invAmount, setInvAmount] = useState(100000);
  const [niftyEndLevel, setNiftyEndLevel] = useState();
  const [loader, setLoader] = useState(true);
  const [finalInvestmentValue, setFinalInvestmentValue] = useState();
  const niftyMulitplier = props?.mldAssetDetails?.multiplier;
  const [maturityCoupon, setMaturityCoupon] = useState(
    niftyReturns * niftyMulitplier
  );
  const minReturns = props?.mldAssetDetails?.minReturns;
  const maxReturns = props?.mldAssetDetails?.maxReturns;
  const [bondfaq, setBondFaq] = useState();
  const [result, setResult] = useState();
  const [isSection, setIsSection] = useState(true); // this page need faq sections

  const scrollToSection = (refToLearn) => {
    if (refToLearn && refToLearn.current) {
      refToLearn.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  useEffect(() => {
    getFaq("bonds", props.product).then((response) => {
      if (!response.success) {
        return toast.error(response.message);
      } else {
        setBondFaq(response?.data?.questions);
      }
    });
  }, []);

  useEffect(() => {
    if (!isSection && bondfaq) {
      // flat data without section
      const allContentArrays = bondfaq.map((item) => item.content).flat();
      setResult(allContentArrays);
    } else {
      // data with section
      setResult(bondfaq);
    }
  }, [bondfaq]);

  useEffect(() => {
    if (props.product != "mld4") {
      setNiftyEndLevel(
        (firstLevel + firstLevel * (niftyReturns / 100)).toFixed(0)
      );
    }
  }, [firstLevel, niftyReturns]);

  useEffect(() => {
    if (props.product !== "mld4") {
      const rawReturns = niftyMulitplier * niftyReturns;
      const returns =
        rawReturns === 0 ? 0 : Number(rawReturns.toFixed(2));
  
      if (returns < minReturns) {
        setMaturityCoupon(minReturns);
      } else if (returns > maxReturns) {
        setMaturityCoupon(maxReturns);
      } else {
        setMaturityCoupon(returns);
      }
    }
  }, [niftyReturns, maxReturns, minReturns]);
  

  useEffect(() => {
    if (props.product != "mld4") {
      setFinalInvestmentValue(invAmount + invAmount * (maturityCoupon / 100));
    }
  }, [invAmount, maturityCoupon]);

  useEffect(() => {
    if (props.product === "mld4") {
      let coupon = 0;

      if (niftyReturns < 0) {
        coupon = 0;
      } else if (niftyReturns <= 10) {
        coupon = niftyReturns;
      } else if (niftyReturns <= 35) {
        coupon = 2 * (niftyReturns - 10) + 10;
      } else {
        coupon = 40;
      }

      setMaturityCoupon(coupon);
      setFinalInvestmentValue((invAmount * (100 + coupon)) / 100);
      // setNiftyEndLevel(firstLevel * (100 + coupon) / 100);
      setNiftyEndLevel(
        (firstLevel + firstLevel * (niftyReturns / 100)).toFixed(0)
      );
    }
  }, [invAmount, firstLevel, niftyReturns]);

  useEffect(() => {
    const locationHash = window.location.hash;
    ReactGA.send({ hitType: "pageview", page_location: `${locationHash}` });
    {
      process.env.REACT_APP_RENDER_GA === "true" &&
        setAnalyticsEvent(locationHash, `${locationHash}`);
    }
  }, []);

  useEffect(() => {
    if (props.mldAssetDetails) {
      if (props.mldAssetDetails && Object.keys(props.mldAssetDetails).length) {
        setLoader(false);
      }
      const isGoldFutures = props?.mldAssetDetails?.bondId === "gmldm0" || props?.mldAssetDetails?.bondId === "gmld1";
      const benchmarkLabel = isGoldFutures ? "Gold Futures MCX" : props?.mldAssetDetails?.bondId === "mld5" ? "NIFTY 50 Index Futures on NSE" : "Nifty 50 Index";
      const issueListTemp = [
        {
          point: "Minimum Investment",
          explaination: props?.mldAssetDetails?.minAmt
            ? props.mldAssetDetails.minAmt.oroNumber(2, true)
            : "NA",
        },
        {
          point: "Underlying Asset",
          explaination: isGoldFutures
          ? "Gold Futures MCX"
          : props?.mldAssetDetails?.bondId === "mld5"
          ? "NIFTY 50 Index Futures on NSE"
          : "Nifty 50 Index",
          infoic: "true",
          // popOvertext: "The Issue Date is " + moment(props?.mldAssetDetails?.issueDate)?.format("Do MMM'YY") + " and the Starting Nifty Level Date is 29th Aug'23"
          popOvertext:
          "This refers to the Market Benchmark (in this case " + benchmarkLabel + ") that is used to determine the returns of the MLD.",
        },
        {
          point: "Multiplier",
          explaination: props?.mldAssetDetails?.multiplier
            ? (props?.productDetails?.ISIN === "INE321N07418" ? "Up to " : "") +
              props.mldAssetDetails.multiplier?.toFixed(1) +
              "x"
            : "NA",
          infoic: "true",
          popOvertext:
          props.mldAssetDetails.bondId === "mld4"
            ? "If 0% ≤ NIFTY Performance < 10% Final Redemption = 100% + 1 X [NIFTY Performance] If 10% ≤ NIFTY Performance ≤ 35% Final Redemption = 110% + 2 X [NIFTY Performance -10%]"
            : "The returns on the Underlying Asset (in this case " +
              benchmarkLabel +
              ") will be multiplied by " +
              props?.mldAssetDetails?.multiplier?.toFixed(1) +
              "x to arrive at the returns of the MLD.",
        },
        {
          point: "Credit Rating",
          explaination: props?.mldAssetDetails?.rating
            ? props.mldAssetDetails.rating
            : "NA",
          learnMore: false,
          learnVideoSrc:
            "https://www.youtube.com/watch?v=Vm7qM1wmXwE&list=PLC3y8-rFHvwjOKd6gdf4QtV1uYNiQnruI&index=6",
        },
        {
          point: "Principal Repayment",
          explaination: props?.mldAssetDetails?.principalRepayment
            ? props.mldAssetDetails.principalRepayment
            : "NA",
        },
        {
          point: "Returns Payout",
          explaination: props?.mldAssetDetails?.listing
            ? props.mldAssetDetails.listing
            : "NA",
        },
        {
          point: "Maturity Date",
          explaination: props?.mldAssetDetails?.maturityDate
            ? moment(props.mldAssetDetails.maturityDate)
                ?.format("Do MMM YY")
                .replace(/(\d)(st|nd|rd|th)/g, "$1<sup>$2</sup>")
            : "NA",
          popOvertext:
            "Maturity refers to the tenor of the investment (in this case " +
            moment(props?.mldAssetDetails?.maturityDate)
              ?.format("Do MMM YY")
              .replace(/(\d)(st|nd|rd|th)/g, "$1<sup>$2</sup>") +
            ")",
        },
        {
          point: "Max. Returns",
          explaination: props?.mldAssetDetails?.maxReturns
            ? props.mldAssetDetails.maxReturns + "%"
            : "NA",
          infoic: "true",
          popOvertext:
            "The returns on the MLD cannot exceed " +
            props?.mldAssetDetails?.maxReturns +
            "%" +
            " irrespective of " + benchmarkLabel + " returns.",
        },
        {
          point: "Min. Returns",
          explaination: props?.mldAssetDetails?.minReturns
            ? props.mldAssetDetails.minReturns + "%"
            : props?.mldAssetDetails?.minReturns === 0
            ? "0%"
            : "NA",
          infoic: "true",
          popOvertext:
            "The returns on the MLD cannot be below " +
            props?.mldAssetDetails?.minReturns +
            "%" +
            " irrespective of " + benchmarkLabel + " Returns.",
        },

        {
          point:
            props?.mldAssetDetails?.bondId === "mld3" ||
            props?.mldAssetDetails?.bondId === "mld4" ||
            props?.mldAssetDetails?.bondId === "mld5" ||
            props.mldAssetDetails.bondId === "gmldm0" ||
            props.mldAssetDetails.bondId === "gmld1" 
              ? "Initial Observation Dates"
              : " Initial Fixing Date",
          explaination:
            props?.mldAssetDetails?.bondId === "mld3"
              ? "29<sup>th</sup> Feb 2024 <br/> 28<sup>th</sup> Mar 2024"
              : props?.mldAssetDetails?.bondId === "mld4"
              ? "20<sup>th</sup> June 2024 <br/> 25<sup>th</sup> Jul 2024<br/> 29<sup>th</sup> Aug 2024<br/> 26<sup>th</sup> Sep 2024"
              : props?.mldAssetDetails?.bondId === "mld5"
              ? "20<sup>th</sup> Oct 2025 <br/> 25<sup>th</sup> Nov 2025"
              : (props?.mldAssetDetails?.bondId === "gmldm0" || props?.mldAssetDetails?.bondId === "gmld1")
              ? "07<sup>th</sup> Aug 2025 <br/> 28<sup>th</sup> Aug 2025 <br/> 25<sup>th</sup> Sep 2025 <br/> 30<sup>th</sup> Oct 2025 <br/> 27<sup>th</sup> Nov 2025 <br/> 24<sup>th</sup> Dec 2025"
              : "31<sup>st</sup> Aug 2023",
          infoic:
            props?.mldAssetDetails?.bondId === "mld3" ||
            props.mldAssetDetails.bondId === "mld4"
              ? true
              : false,
          popOvertext:
            props?.mldAssetDetails?.bondId === "mld3"
              ? "The Initial Fixing level would be the average of Nifty 50 Index levels on 29th Feb’24 & 28th Mar’24"
              : props?.mldAssetDetails?.bondId === "mld4"
              ? " The Initial Fixing level would be the average of Nifty 50 Index levels on 20/06/2024, 25/07/2024, 29/08/2024 and 26/09/2024."
              : "",
        },

        {
          point:
            props?.mldAssetDetails?.bondId === "mld3" ||
            props?.mldAssetDetails?.bondId === "mld4" ||
            props?.mldAssetDetails?.bondId === "mld5" ||
            props.mldAssetDetails.bondId === "gmldm0" ||
            props.mldAssetDetails.bondId === "gmld1" 
              ? "Final Observation Dates"
              : "Initial Fixing Level",
          explaination:
            props?.mldAssetDetails?.bondId === "mld3"
              ? "29<sup>th</sup> Jan 2026 <br/> 26<sup>th</sup> Feb 2026"
              : props?.mldAssetDetails?.bondId === "mld4"
              ? "29<sup>th</sup> Apr 2027 <br/> 27<sup>th</sup> May 2027<br/> 24<sup>th</sup> Jun 2027<br/> 29<sup>th</sup> Jul 2027"
              : props?.mldAssetDetails?.bondId === "mld5"
              ? "28<sup>th</sup> Sept 2027 <br/> 26<sup>th</sup> Oct 2027"
              // 28/09/2027 and 26/10/2027
              : (props?.mldAssetDetails?.bondId === "gmldm0" || props?.mldAssetDetails?.bondId === "gmld1")
              ? "25<sup>th</sup> May 2028 <br/> 29<sup>th</sup> Jun 2028 <br/> 27<sup>th</sup> Jul 2028 <br/> 31<sup>st</sup> Aug 2028 <br/> 28<sup>th</sup> Sep 2028 <br/> 26<sup>th</sup> Oct 2028"
              : "24,900",
          infoic:
            props?.mldAssetDetails?.bondId === "mld3" ||
            props.mldAssetDetails.bondId === "mld4"
              ? true
              : false,
          popOvertext:
            props?.mldAssetDetails?.bondId === "mld3"
              ? "The Final Fixing level would be the average of Nifty 50 Index levels on 29th Jan’26 & 26th Feb’26"
              : props?.mldAssetDetails?.bondId === "mld4"
              ? "The Final Fixing level would be the average of Nifty 50 Index levels on 29/04/2027, 27/05/2027, 24/06/2027 & 29/07/2027."
              : "",
        },
      ];
      setIssueList(issueListTemp);
    }
  }, [props.mldAssetDetails]);

  const handleFirstLevelChange = (event) => {
    setFirstLevel(Number(event.target.value));
  };

  const handleNiftyReturns = (val) => {
    setNiftyReturns(Number(val.target.value));
  };

  const handleInvAmount = (amt) => {
    setInvAmount(Number(amt.target.value));
  };

  const toggleVideoModal = () => {
    setShowVideo(!showVideo);
  };

  const toggleEstimatePopup = () => {
    setShowEstimatePopup(!showEstimatePopup);
  };

  return props?.isAdvisory ? (
    <></>
  ) : (
    <>
      <div ref={!props.isMobile ? props.investSectionRef : null}></div>
      <div className="mld-invest-main">
        {loader ? (
          <div className="mt-2">
            <OroLoader />
          </div>
        ) : (
          <>
            <FirstFold
              issueList={issueList}
              mldAssetDetails={props.mldAssetDetails}
              refToLearn={refToLearn}
              scrollToSection={props.scrollToSection}
              investRef={props.investSectionRef}
              increaseUnits={props.increaseUnits}
              decreaseUnits={props.decreaseUnits}
              setUnitsFunc={props.setUnitsFunc}
              goToPaymentOverview={props.startInvest}
              showConsent={props.showConsent}
              units={props.units}
              errors={props.errors}
              userState={props.userState}
              priceResponse={props.priceResponse}
              toggleVideoModal={toggleVideoModal}
              toggleEstimatePopup={toggleEstimatePopup}
              staticContent={mldInvest}
              isNewJourney={props.isNewJourney}
              isKycDone={props.isKycDone}
              isUserInvested={props.portfolioValue?.data?.pfStats?.investedAmt}
              isMobile={props?.isMobile}
              thirdPartyData={props?.thirdPartyData}
              isModalOpen={props?.isModalOpen}
              toggleHvInitiateModal={props.toggleHvInitiateModal}
              hypervergeVerification={props.hypervergeVerification}
            />

            {!props.isOngoingOrder &&
            !props.loader &&
            props.transactions.length ? (
              <>
                <div ref={props.txnRef} />
                <WLTransactionHistory
                  isMobile={props.isMobile}
                  transactions={props.transactions}
                  portfolio={props.portfolioValue}
                  productDetails={props?.mldAssetDetails}
                />
              </>
            ) : (
              ""
            )}
            <SecondFold
              mldAssetDetails={props.mldAssetDetails}
              isMobile={props.isMobile}
              showSecondDiv={true}
              fromMldPage={true}
            />
            <MldReturns
              mldAssetDetails={props.mldAssetDetails}
              mldInvest={mldInvest}
              toggleEstimatePopup={toggleEstimatePopup}
              isMobile={props.isMobile}
            />
            <AboutIcm
              mldAssetDetails={props.mldAssetDetails}
              isMobile={props.isMobile}
              assetDetails={mldInvest && mldInvest.aboutIncred}
              investRef={props.investSectionRef}
              scrollToSection={scrollToSection}
              productDetails={props.productDetails}
            />
            <WhyIcm
              mldAssetDetails={props.mldAssetDetails}
              whyIcm={mldInvest && mldInvest.whyIcm}
            />
            <MldRisk mldAssetDetails={props.mldAssetDetails} isMobile={props.isMobile}/>
            <EstimateModal
              showEstimatePopup={showEstimatePopup}
              toggleEstimatePopup={toggleEstimatePopup}
              handleFirstLevelChange={handleFirstLevelChange}
              firstLevel={firstLevel}
              handleNiftyReturns={handleNiftyReturns}
              niftyReturns={niftyReturns}
              invAmount={invAmount}
              handleInvAmount={handleInvAmount}
              niftyEndLevel={niftyEndLevel}
              maturityCoupon={maturityCoupon}
              niftyMulitplier={niftyMulitplier}
              finalInvestmentValue={finalInvestmentValue}
              fromIndexPage={false}
              fromProductPage={true}
              mldAssetDetails={props?.mldAssetDetails}
              minReturns={minReturns}
              maxReturns={maxReturns}
              product={props.product}
            />
            <ResourceFold
              mldAssetDetails={props.mldAssetDetails}
              refToLearn={refToLearn}
              fromMldPage={true}
            />
            <MldMarketingFaq mldMarketingFaq={result} />
            {props?.showConsultbanner ? (
              <ConsultBanner closeConsultBanner={props?.closeConsultBanner} />
            ) : null}
          </>
        )}
      </div>
    </>
  );
});

export default MldAssets;
